import { useState, useCallback } from 'react'
import { stripeService } from '../services/stripeService'
import { useLanguage } from './useLanguage'
import toast from 'react-hot-toast'

export const usePayment = () => {
  const { t } = useLanguage()
  const [isProcessing, setIsProcessing] = useState<'first' | 'second' | null>(null)

  const handlePayment = useCallback(async (
    trancheType: 'first' | 'second',
    bookingId: string,
    tripName: string,
    codiceScontoId?: string
  ) => {
    setIsProcessing(trancheType)
    
    try {
      await stripeService.handlePayment(trancheType, bookingId, codiceScontoId)
      
      const trancheLabel = trancheType === 'first' ? t('payment.depositLabel') : t('payment.balanceLabel')
      toast.success(`Reindirizzamento al pagamento ${trancheLabel}...`)
      
      return { success: true }
    } catch (error: any) {
      console.error(`Errore nel pagamento ${trancheType}:`, error)
      
      // Se è un errore di posti insufficienti, non mostrare un toast aggiuntivo
      // perché è già stato mostrato dal stripeService
      if (error.message === 'INSUFFICIENT_SPOTS') {
        return { success: false, error: 'INSUFFICIENT_SPOTS' }
      }
      
      const trancheLabel = trancheType === 'first' ? t('payment.depositLabel') : t('payment.balanceLabel')
      toast.error(`Errore durante il pagamento ${trancheLabel}. Riprova.`)
      
      return { success: false, error }
    } finally {
      setIsProcessing(null)
    }
  }, [])

  const isStripeAvailable = useCallback(async () => {
    return await stripeService.isStripeAvailable()
  }, [])

  return {
    handlePayment,
    isStripeAvailable,
    isProcessing
  }
} 